import { CartInterface } from 'src/types/cart';

export const checkIfProductInCart = (cart: CartInterface[], productId: string) =>
  cart.some((item) => item?.productId === productId);
